import { ConnectKitProvider } from 'connectkit';
import { Provider } from 'react-redux';
import ThemeProvider from './theme';
import { MotionLazyContainer } from './components/animate';
import Router from './routes';
import { store } from './redux/store';
import WagmiProvier from './components/wagmi/WagmiProvier';

function App() {
  return (
    <WagmiProvier>
      <Provider store={store}>
        <MotionLazyContainer>
          <ThemeProvider>
            <ConnectKitProvider theme="midnight">
              <Router />
            </ConnectKitProvider>
          </ThemeProvider>
        </MotionLazyContainer>
      </Provider>
    </WagmiProvier>
  );
}

export default App;
